module.exports = __webpack_public_path__ + "img/logo-sepatu-kw-1.580eb5b8.png";